// extracted by mini-css-extract-plugin
export default {"button":"ButtonStandard_button__W77Vo"};